/* Fabrica de Baterii — comportamente globale */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var topBtn = null;

  /* clasa pe body la scroll (umbră header, back-to-top) */
  var lastState = false;
  function onScroll() {
    var s = window.scrollY > 24;
    if (s !== lastState) {
      lastState = s;
      document.body.classList.toggle('fdb-scrolled', s);
    }
    if (topBtn) topBtn.classList.toggle('is-on', window.scrollY > 600);
    if (progressBar) updateProgress();
  }

  /* bara de progres la citit, doar pe pagini de articol */
  var progressBar = null;
  function updateProgress() {
    var doc = document.documentElement;
    var total = doc.scrollHeight - window.innerHeight;
    var p = total > 0 ? (window.scrollY / total) * 100 : 0;
    progressBar.style.width = Math.min(100, Math.max(0, p)).toFixed(1) + '%';
  }

  function init() {
    document.body.classList.add('fdb-js');

    /* back-to-top */
    topBtn = document.createElement('button');
    topBtn.className = 'fdb-top-btn';
    topBtn.type = 'button';
    topBtn.setAttribute('aria-label', 'Înapoi sus');
    topBtn.innerHTML = '↑';
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
    document.body.appendChild(topBtn);

    /* progres citire pe articole */
    if (document.querySelector('.article-template')) {
      progressBar = document.createElement('div');
      progressBar.className = 'fdb-read-progress';
      progressBar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(progressBar);
    }

    /* reveal în cascadă pentru cardurile de produs / colecție / blog */
    if (!reduced && 'IntersectionObserver' in window) {
      var cards = document.querySelectorAll(
        '.product-grid .card-wrapper, .collection .card-wrapper, .blog-articles .article-card-wrapper, .collection-list .card-wrapper'
      );
      if (cards.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('fdb-in');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
        cards.forEach(function (el, i) {
          el.classList.add('fdb-stagger');
          el.style.setProperty('--fdb-delay', (i % 4) * 70 + 'ms');
          io.observe(el);
        });
      }
    }

    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }
  }, { passive: true });
})();
